import PropTypes from 'prop-types';
import {Button, Card} from 'semantic-ui-react';
import {BLANK_TEXT} from '../../utils';

function ConsultPackage(props) {
  const {consultPackage} = props;
  return (
    <Card color='green'>
      <Card.Content textAlign='center' header={consultPackage.name}/>
      <Card.Content textAlign='center' description={consultPackage.description || BLANK_TEXT}/>
      <Card.Content extra textAlign='center'>
        {`مدت اعتبار : ${consultPackage.duration} روز`}
      </Card.Content>
      <Card.Content extra textAlign='center'>
        {`قیمت : ${consultPackage.price.toLocaleString()} ریال`}
      </Card.Content>
      <Card.Content textAlign='center'>
        <Button
          positive
          onClick={props.onClick}
          content='خرید بسته مشاوره'
        />
      </Card.Content>
    </Card>
  );
}


ConsultPackage.propTypes = {
  consultPackage: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ConsultPackage;
